export default __webpack_public_path__ + "static/media/ContestRank1.f42f5d9a.svg";